module.exports = __webpack_public_path__ + "img/level_6.e35e2768.svg";